var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M423 19c224,0 404,181 404,404 0,224 -180,404 -404,404 -223,0 -404,-180 -404,-404 0,-223 181,-404 404,-404zm0 344l150 -149 60 60 -150 149 150 150 -60 60 -150 -150 -149 150 -60 -60 149 -150 -149 -149 60 -60 149 149z"})));
}

Close.defaultProps = {"height":"100px","width":"100px","version":"1.1","viewBox":"0 0 847 847","x":"0px","y":"0px","fillRule":"evenodd","clipRule":"evenodd"};

module.exports = Close;

Close.default = Close;
